import React from 'react';
import { registry } from '../../core/Registry.js';
import { BaseWidget } from '../BaseWidget.jsx';

export function AlertRender({ node }) {
  const content = node.content || {};
  
  const type = content.type || 'info'; // info, success, warning, error
  const title = content.title || 'Hinweis';
  const text = content.text || 'Dies ist eine wichtige Information für den Kunden.';
  
  let bg = 'rgba(0, 169, 224, 0.1)';
  let border = '#00A9E0';
  let icon = 'ℹ️';

  if (type === 'success') { bg = 'rgba(16, 185, 129, 0.1)'; border = '#10b981'; icon = '✅'; }
  if (type === 'warning') { bg = 'rgba(245, 158, 11, 0.1)'; border = '#f59e0b'; icon = '⚠️'; }
  if (type === 'error') { bg = 'rgba(239, 68, 68, 0.1)'; border = '#ef4444'; icon = '❌'; }

  return (
    <div style={{
      display: 'flex',
      alignItems: 'flex-start',
      gap: '16px',
      padding: '20px',
      background: bg,
      borderLeft: `4px solid ${border}`,
      borderRadius: '0 8px 8px 0',
      width: '100%'
    }}>
      <div style={{ fontSize: '24px', lineHeight: 1 }}>{icon}</div>
      <div>
        <h4 style={{ margin: '0 0 6px 0', fontSize: '16px', fontWeight: 'bold', color: '#f8fafc' }}>{title}</h4>
        <p style={{ margin: 0, fontSize: '14px', color: '#cbd5e1', lineHeight: '1.5' }}>{text}</p>
      </div>
    </div>
  );
}

registry.register('Alert', {
  label: 'Hinweis-Box (Alert)',
  icon: '🚨', 
  category: 'basic',
  component: AlertRender,
  
  defaultProps: {
    content: {
      type: 'info',
      title: 'Aktion verlängert',
      text: 'Der Anschlusspreis entfällt noch bis Ende des Monats für alle O2 Mobile Tarife!'
    },
    style: {
      desktop: {
        marginBottom: '20px'
      }
    }
  },

  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Hinweis Typ',
          fields: [
            { name: 'content.type', label: 'Art des Hinweises', type: 'select', options: ['info', 'success', 'warning', 'error'] }
          ]
        },
        {
          title: 'Inhalt',
          fields: [
            { name: 'content.title', label: 'Titel', type: 'text' },
            { name: 'content.text', label: 'Nachricht', type: 'textarea' }
          ]
        }
      ]
    }
  ]
});
